import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const LoginResponse = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                // Procesa SOLO el redirect; no relances login aquí
                const resp = await instance.handleRedirectPromise();
                if (resp?.account) {
                    instance.setActiveAccount(resp.account);
                } else {
                    // Si ya hay cuenta en caché, establécela
                    const acc = instance.getAllAccounts()[0];
                    if (acc) instance.setActiveAccount(acc);
                }
                // Navega a tu home o dashboard
                if (mounted) navigate("/");
            } catch (err) {
                console.error("Error procesando redirect:", err);
                if (mounted) navigate("/"); // decide a dónde ir si falla
            } finally {
                if (mounted) setLoading(false);
            }
        })();

        return () => { mounted = false; };
    }, [instance, navigate]);

    return <div>{loading ? "Procesando login..." : "Redirigiendo..."}</div>;
};

export default LoginResponse;
